import "./button.css";

export default function Button({ label, icon, extra_classes, style, onClick, ariaLabel, ariaDescribedBy }) {
   return (
      <button 
         className={ "button " + ( extra_classes || "" )}
         style={ style }
         onClick={ onClick }
         aria-label={ ariaLabel || label }
         aria-describedby={ ariaDescribedBy }
      >
         { icon === "add" && 
            <svg className="stroke" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
               <path d="M1 8.5H15" strokeWidth="2" strokeLinecap="round"/>
               <path d="M8 1.5L8 15.5" strokeWidth="2" strokeLinecap="round"/>
            </svg>
         }
         
         { icon === "prev" && 
            <svg className="stroke" width="29" height="16" viewBox="0 0 29 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
               <path d="M28 8L2 8M2 8L9.33333 15M2 8L9.33333 0.999998" strokeWidth="2" strokeLinecap="round"/>
            </svg>
         }

         { icon === "download" && 
            <svg className="stroke" width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
               <path d="M11 17.4824L11 1.48242M11 17.4824L5 11.4824M11 17.4824L17 11.4824M1 23.4824L21 23.4824" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
         }

         { icon === "share" && 
            <svg className="fill" width="22" height="23" viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
               <path d="M17.4324 14.6161C16.167 14.6161 15.0387 15.2191 14.3169 16.151L8.2733 12.7752C8.41491 12.3686 8.49257 11.9301 8.49257 11.4779C8.49257 11.021 8.41491 10.5871 8.26873 10.1759L14.3078 6.80468C15.025 7.74114 16.1579 8.3487 17.4278 8.3487C19.5931 8.3487 21.3609 6.58541 21.3609 4.41556C21.3609 2.24571 19.5976 0.482422 17.4278 0.482422C15.2579 0.482422 13.4946 2.24571 13.4946 4.41556C13.4946 4.87237 13.5723 5.31091 13.7185 5.71747L7.68402 9.08873C6.96682 8.1477 5.83393 7.54471 4.564 7.54471C2.39872 7.54471 0.630859 9.308 0.630859 11.4779C0.630859 13.6477 2.39872 15.411 4.56857 15.411C5.8385 15.411 6.97139 14.8034 7.69315 13.8624L13.7322 17.2382C13.586 17.6494 13.5038 18.0925 13.5038 18.5493C13.5038 20.7146 15.2671 22.4824 17.4369 22.4824C19.6068 22.4824 21.3701 20.7191 21.3701 18.5493C21.3701 16.3794 19.6022 14.6161 17.4324 14.6161ZM17.4324 1.72038C18.9216 1.72038 20.1321 2.93093 20.1321 4.42013C20.1321 5.90933 18.9216 7.11988 17.4324 7.11988C15.9432 7.11988 14.7326 5.90933 14.7326 4.42013C14.7326 2.93093 15.9477 1.72038 17.4324 1.72038ZM4.56857 14.1776C3.07936 14.1776 1.86882 12.9671 1.86882 11.4779C1.86882 9.98865 3.07936 8.7781 4.56857 8.7781C6.05777 8.7781 7.26832 9.98865 7.26832 11.4779C7.26832 12.9671 6.0532 14.1776 4.56857 14.1776ZM17.4324 21.2445C15.9432 21.2445 14.7326 20.0339 14.7326 18.5447C14.7326 17.0555 15.9432 15.845 17.4324 15.845C18.9216 15.845 20.1321 17.0555 20.1321 18.5447C20.1321 20.0339 18.9216 21.2445 17.4324 21.2445Z"/>
            </svg>
         }

         { label }
         
         { icon === "next" && 
            <svg className="stroke" width="29" height="16" viewBox="0 0 29 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
               <path d="M1 8H27M27 8L19.6667 1M27 8L19.6667 15" strokeWidth="2" strokeLinecap="round"/>
            </svg>
         }
      </button>
   )
}